import { useTranslation } from 'react-i18next';
import { DialogContent, Grid, Stack, Typography } from '@mui/material';
import RetryInstructions from './RetryInstructions';
import IgnoreInstructions from './IgnoreInstructions';

function NoDevice({ device }) {
  const { t } = useTranslation();

  return (
    <DialogContent>
      <Stack spacing={2}>
        <Grid item>
          <Typography fontSize="14px">
            {t(`Please check that your ${device} is connected and functional.`)}
            <RetryInstructions />
          </Typography>
        </Grid>
        <IgnoreInstructions device={device} />
      </Stack>
    </DialogContent>
  );
}

export default NoDevice;
